export type SubscriptionStatus = 'active' | 'inactive';

export class Subscription {

    public expires_at: Date;
    public purchase_token: string;
    public purchased_at: Date;
    public renewed_at: Date;
    public status: SubscriptionStatus;
    public subscription_id: string;
    public type: string;

    public static createMany(data: Partial<Subscription>[]): Subscription[] {
        let subscriptions: Subscription[] = [];
        for (let item of data) {
            if (!data) continue;
            subscriptions.push(Subscription.createOne(item));
        }
        return subscriptions;
    }

    public static createOne(data: Partial<Subscription>): Subscription {
        if (!data) return null;
        let subscription = new Subscription();
        subscription.fill(data);
        return subscription;
    }

    public fill(data: Partial<Subscription>) {
        if (!data) return;

        this.expires_at = data.expires_at ? new Date(data.expires_at) : null;
        this.purchase_token = data.purchase_token || null;
        this.purchased_at = data.purchased_at ? new Date(data.purchased_at) : null;
        this.renewed_at = data.renewed_at ? new Date(data.renewed_at) : null;
        this.status = data.status || null;
        this.subscription_id = data.subscription_id || null;
        this.type = data.type || null;
    }

}



// WEBPACK FOOTER //
// ./src/models/subscription.ts